const PROPERTY_ACCESS_REASONS = {
  DOG: "Dog",
  SECURITY_CODE: "Security code",
  OTHER: "Other",
};

export { PROPERTY_ACCESS_REASONS };
